module.exports = __webpack_public_path__ + "img/workflow.6d1828a8.svg";